import { createBrowserRouter } from 'react-router';
import { PublicLayout } from './public/PublicLayout';
import { HomePage } from './public/HomePage';
import { InventoryPage } from './public/InventoryPage';
import { ProductDetailPage } from './public/ProductDetailPage';

export const router = createBrowserRouter([
  {
    element: <PublicLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'inventory', element: <InventoryPage /> },
      { path: 'inventory/:slug', element: <ProductDetailPage /> },
      {
        path: 'preorder',
        lazy: () => import('./public/PreorderPage').then((m) => ({ Component: m.PreorderPage })),
      },
    ],
  },
  {
    path: 'admin',
    lazy: () => import('./admin/AdminLayout').then((m) => ({ Component: m.AdminLayout })),
    children: [
      {
        index: true,
        lazy: () =>
          import('./admin/AdminInventoryPage').then((m) => ({ Component: m.AdminInventoryPage })),
      },
      {
        path: 'preorders',
        lazy: () =>
          import('./admin/AdminPreordersPage').then((m) => ({ Component: m.AdminPreordersPage })),
      },
    ],
  },
]);
